export default {"src":"/blog/_next/static/media/card-squiggles.4a10ade4.svg","height":210,"width":380};